import React from "react";
import { PlayerCountVsDurationChart } from "./Chart";
import { SinglePageView } from "../core/ListView";
import Alert from "@mui/material/Alert";
import Box from "@mui/material/Box";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
import GridOn from "@mui/icons-material/GridOn";
import ScatterPlot from "@mui/icons-material/ScatterPlot";
import Stack from "@mui/material/Stack";
import { useGamePlayTests } from "@seabrookstudios/pitch2table";

/**
 * @param {object} props
 * @param {import("@seabrookstudios/types").GameId} props.gameId
 */
export const PlayerCountVsDuration = ({ gameId }) => {
  const { data: playTests = [] } = useGamePlayTests(gameId);
  const [groupByIntervals, setGroupByIntervals] = React.useState(false);

  const toggleGroupByIntervals = () => {
    setGroupByIntervals((x) => !x);
  };

  const playTestsWithData = playTests.filter((pt) => pt.duration && pt.ignore && pt.outcomes.length > 0);
  const incompletePlayTests = playTests.filter((pt) => (!pt.duration || pt.outcomes.length === 0) && pt.ignore);

  const ChartActions = () => {
    return (
      <Stack direction="row" pr={1}>
        <Tooltip title={"Toggle 5-minute interval grouping"}>
          <IconButton onClick={toggleGroupByIntervals}>{groupByIntervals ? <GridOn /> : <ScatterPlot />}</IconButton>
        </Tooltip>
      </Stack>
    );
  };

  return (
    <SinglePageView
      title={`Player Count vs Duration (${groupByIntervals ? "5-min Intervals" : "Exact Times"})`}
      Action={ChartActions}
    >
      {playTestsWithData.length === 0 ? (
        <Box p={1}>
          <Alert severity="warning">
            To use this chart you need to record both duration and have players for your play tests. Update your play
            tests to include duration information.
          </Alert>
        </Box>
      ) : (
        <Box p={1}>
          <Alert severity="info">
            This chart shows the relationship between player count and game duration. Each point represents a play test.
            {groupByIntervals && " Durations are grouped into 5-minute intervals (e.g., 6 minutes becomes 10 minutes)."}
            {incompletePlayTests.length > 0 && (
              <>
                {" "}
                There are {incompletePlayTests.length} play test{incompletePlayTests.length === 1 ? "" : "s"} without
                complete data.
              </>
            )}
          </Alert>
        </Box>
      )}
      <PlayerCountVsDurationChart gameId={gameId} groupByIntervals={groupByIntervals} />
    </SinglePageView>
  );
};
